<script setup>
import "rangeslider.js";
import 'rangeslider.js/dist/rangeslider.css';

import { onMounted, ref } from "vue";
onMounted(() => {
  
  $('input[type="range"]').rangeslider({
      polyfill: false,

      // Default CSS classes
      rangeClass: "rangeslider",
      disabledClass: "rangeslider--disabled",
      horizontalClass: "rangeslider--horizontal",
      verticalClass: "rangeslider--vertical",
      fillClass: "rangeslider__fill",
      handleClass: "rangeslider__handle",

      onInit: function () {},

      onSlide: function (position, value) {},

      onSlideEnd: function (position, value) {},
    });
});
const tab = ref(null)
</script>
<template>
  <main class="mt-[60px] md:mt-[70px]">
    <div>
      <div class="mx-auto flex max-w-[960px] gap-10 px-4 pb-4 lg:px-0">
        <div class="w-full flex-1 md:max-w-[600px]">
          <div>
            <div
              class="no-scrollbar mt-4 flex overflow-x-auto pt-4 md:mt-6"
              aria-label="Breadcrumb"
            >
              <ol class="inline-flex items-center">
                <li>
                  <div class="flex items-center text-sm font-normal">
                    <a
                      href="/"
                      class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                      >Home</a
                    >
                    <div class="px-2">/</div>
                  </div>
                </li>
                <li>
                  <div class="flex items-center text-sm font-normal">
                    <a
                      href="/calculator/"
                      class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                      >Calculators</a
                    >
                    <div class="px-2">/</div>
                  </div>
                </li>
                <li
                  class="w-50 truncate pr-7 text-sm font-normal text-lighter-black sm:w-72"
                >
                  Lumpsum Calculator
                </li>
              </ol>
            </div>
            <h1
              class="my-1 text-2xl font-semibold not-italic leading-8 tracking-[-0.24px] md:my-2"
            >
              Lumpsum Calculator
            </h1>
            <p
              class="mb-7 text-sm font-normal not-italic leading-6 text-grey-8 md:text-base"
            >
              Estimate future returns and optimise your investment strategy with
              our lumpsump calculator. Start growing your wealth with the best
              plans today!
            </p>
            <div
              class="no-scrollbar border-b-blacks-3 flex h-[var(--tab-bar-height)] overflow-x-scroll border-b"
            >
              <a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer text-dark-2 transition-colors"
                href="/calculator/sip-calculator/"
                ><div class="ipad:px-1 px-3">SIP</div></a
              ><a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer border-b-2 border-b-primary-base pb-2 font-semibold text-main-6"
                href="/calculator/lumpsum-calculator/"
                ><div class="ipad:px-1 px-3">Lumpsum</div></a
              >
            </div>
            <div class="flex flex-col gap-6">
              <div class="pt-[16px]">
                <div class="upstox-radio-group" role="radiogroup">
                  <div class="radio-wrapper">
                    <input
                      type="radio"
                      id="I know my investment"
                      class="radio-input"
                      name="investment-goal-radio-group"
                      checked=""
                      value="investment"
                    /><label
                      role="radio"
                      aria-checked="true"
                      tabindex="0"
                      for="I know my investment"
                      class="radio-label"
                      >I know my investment</label
                    >
                  </div>
                  <div class="radio-wrapper">
                    <input
                      type="radio"
                      id="I know my goal"
                      class="radio-input"
                      name="investment-goal-radio-group"
                      value="goal"
                    /><label
                      role="radio"
                      aria-checked="false"
                      tabindex="0"
                      for="I know my goal"
                      class="radio-label"
                      >I know my goal</label
                    >
                  </div>
                </div>
              </div>
              <div>
                <div class="flex w-full items-center justify-between mb-2">
                  <div class="w-full max-w-[173px] md:max-w-[551px]">
                    <label
                      class="text-sm leading-5 text-black-6 font-semibold"
                      for="Lumpsum amount"
                      >Lumpsum amount</label
                    >
                  </div>
                  <div class="relative">
                    <span
                      class="absolute left-3 top-[10px] mr-6 text-xs font-medium leading-4 text-dark-2"
                      >₹</span
                    ><input
                      class="h-[36px] rounded border !border-grey-9 !px-3 !py-2 text-xs font-medium leading-4 disabled:cursor-not-allowed disabled:bg-grey-7 disabled:text-grey-2 !pl-[20px] !w-[112px] md:!w-[112px] !mb-0"
                      type="text"
                      id="Lumpsum amount"
                      name="Lumpsum amount"
                      value="5000"
                    />
                  </div>
                </div>
                <span
                  dir="ltr"
                  data-orientation="horizontal"
                  aria-disabled="false"
                  class="relative flex h-[50px] w-full select-none items-center px-2"
                  aria-label="Volume"
                  style="--radix-slider-thumb-transform: translateX(-50%)"
                  ><div
                    class="relative h-[2px] flex-grow cursor-pointer rounded-[4px] bg-gray-accent"
                  >
                    <span
                      data-orientation="horizontal"
                      class="absolute h-full rounded-full bg-primary-base"
                      style="left: 0%; right: 99.95%"
                    ></span>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 0%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] invisible bg-primary-base"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-30%]"
                        >0</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 10%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >10L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 20%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >20L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 30%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >30L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 40%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >40L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 50%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >50L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 60%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >60L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 70%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >70L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 80%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >80L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 90%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >90L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 100%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent invisible"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-70%]"
                        >1Cr</span
                      >
                    </div>
                  </div>
                  <span
                    style="
                      transform: var(--radix-slider-thumb-transform);
                      position: absolute;
                      left: calc(0.05% + 11.988px);
                    "
                    ><span
                      role="slider"
                      aria-valuemin="0"
                      aria-valuemax="10000000"
                      aria-orientation="horizontal"
                      data-orientation="horizontal"
                      tabindex="0"
                      class="flex h-6 w-6 cursor-pointer rounded-full bg-primary-base focus:outline-none"
                      style=""
                      data-radix-collection-item=""
                      aria-valuenow="5000"
                    ></span></span
                ></span>
              </div>
              <div class="pb-2">
                <div class="mb-2 flex items-center justify-between">
                  <label class="text-sm leading-5 text-black-6 font-semibold"
                    >Expected return rate (per annum)</label
                  >
                  <div class="flex gap-2">
                    <input
                      class="h-[36px] !w-[56px] rounded border !border-grey-9 !px-2 !py-2 text-xs font-medium leading-4 disabled:cursor-not-allowed disabled:bg-grey-7 disabled:text-grey-2 !mb-0"
                      type="text"
                      id="expected-return-rate"
                      aria-label="Expected return rate (per annum)"
                      name="expected-return-rate"
                      value="12"
                    />
                  </div>
                </div>
                <span
                  dir="ltr"
                  data-orientation="horizontal"
                  aria-disabled="false"
                  class="relative flex h-[50px] w-full select-none items-center px-2"
                  aria-label="Volume"
                  style="--radix-slider-thumb-transform: translateX(-50%)"
                  ><div
                    class="relative h-[2px] flex-grow cursor-pointer rounded-[4px] bg-gray-accent"
                  >
                    <span
                      data-orientation="horizontal"
                      class="absolute h-full rounded-full bg-primary-base"
                      style="left: 0%; right: 76%"
                    ></span>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 0%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] invisible bg-primary-base"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-30%]"
                        >0%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 20%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-primary-base"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >10%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 40%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >20%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 60%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >30%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 80%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >40%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 100%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent invisible"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-70%]"
                        >50%</span
                      >
                    </div>
                  </div>
                  <span
                    style="
                      transform: var(--radix-slider-thumb-transform);
                      position: absolute;
                      left: calc(24% + 6.24px);
                    "
                    ><span
                      role="slider"
                      aria-valuemin="0"
                      aria-valuemax="50"
                      aria-orientation="horizontal"
                      data-orientation="horizontal"
                      tabindex="0"
                      class="flex h-6 w-6 cursor-pointer rounded-full bg-primary-base focus:outline-none"
                      style=""
                      data-radix-collection-item=""
                      aria-valuenow="12"
                    ></span></span
                ></span>
              </div>
              <div class="pb-2">
                <div class="mb-2 flex items-center justify-between">
                  <label class="text-sm leading-5 text-black-6 font-semibold"
                    >Tenure</label
                  >
                  <div class="flex gap-2">
                    <input
                      class="h-[36px] !w-[56px] rounded border border-grey-9 !px-2 !py-2 text-xs font-medium leading-4 disabled:cursor-not-allowed disabled:bg-grey-7 disabled:text-grey-2 !mb-0"
                      type="text"
                      id="sip-tenure"
                      aria-label="Tenure"
                      name="sip tenure"
                      value="5"
                    />
                  </div>
                </div>
                <span
                  dir="ltr"
                  data-orientation="horizontal"
                  aria-disabled="false"
                  class="relative flex h-[50px] w-full select-none items-center px-2"
                  aria-label="Volume"
                  style="--radix-slider-thumb-transform: translateX(-50%)"
                  ><div
                    class="relative h-[2px] flex-grow cursor-pointer rounded-[4px] bg-gray-accent"
                  >
                    <span
                      data-orientation="horizontal"
                      class="absolute h-full rounded-full bg-primary-base"
                      style="left: 0%; right: 90%"
                    ></span>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 0%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] invisible bg-primary-base"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-30%]"
                        >0Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 10%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-primary-base"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >5Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 20%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >10Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 30%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >15Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 40%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >20Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 50%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >25Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 60%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >30Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 70%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >35Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 80%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >40Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 90%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >45Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 100%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent invisible"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-70%]"
                        >50Y</span
                      >
                    </div>
                  </div>
                  <span
                    style="
                      transform: var(--radix-slider-thumb-transform);
                      position: absolute;
                      left: calc(10% + 9.6px);
                    "
                    ><span
                      role="slider"
                      aria-valuemin="0"
                      aria-valuemax="50"
                      aria-orientation="horizontal"
                      data-orientation="horizontal"
                      tabindex="0"
                      class="flex h-6 w-6 cursor-pointer rounded-full bg-primary-base focus:outline-none"
                      style=""
                      data-radix-collection-item=""
                      aria-valuenow="5"
                    ></span></span
                ></span>
              </div>
            </div>
            <hr class="my-6 h-px border-0 bg-grey-7" />
            <div
              class="flex-col items-center gap-1 rounded border border-grey-7 md:gap-0 md:rounded-b-none"
            >
              <div
                class="items-start border-b border-grey-7 bg-gray-50 px-4 py-3"
              >
                <p class="text-sm font-semibold text-gray-primary">
                  Investment vs returns
                </p>
              </div>
              <div
                class="justify-between px-4 pb-6 pt-5 md:flex md:items-center md:gap-0 md:px-12 md:pb-11 md:pt-7"
              >
                <!--$--><!--/$-->
                <div
                  class="w-45 flex h-40 items-center justify-center px-[10px] md:h-[230px] md:w-[230px] md:p-0"
                >
                  <div
                    class="recharts-responsive-container"
                    style="width: 100%; height: 100%; min-width: 0px"
                  >
                    <div
                      class="recharts-wrapper"
                      style="
                        position: relative;
                        cursor: default;
                        width: 100%;
                        height: 100%;
                        max-height: 230px;
                        max-width: 230px;
                      "
                    >
                      <svg
                        cx="50%"
                        cy="50%"
                        class="recharts-surface"
                        width="230"
                        height="230"
                        viewBox="0 0 230 230"
                        style="width: 100%; height: 100%"
                      >
                        <title></title>
                        <desc></desc>
                        <defs>
                          <clipPath id="recharts1-clip">
                            <rect x="5" y="5" height="220" width="220"></rect>
                          </clipPath>
                        </defs>
                        <g
                          class="recharts-layer recharts-pie h-45 w-40 outline-none md:h-[230px] md:w-[230px]"
                          tabindex="0"
                        >
                          <g class="recharts-layer">
                            <g
                              class="recharts-layer recharts-pie-sector"
                              tabindex="-1"
                            >
                              <path
                                cx="115"
                                cy="115"
                                name="Invested amount"
                                class="recharts-sector h-45 w-40 outline-none md:h-[230px] md:w-[230px]"
                                stroke="#fff"
                                fill="#AE8AD2"
                                cursor="pointer"
                                tabindex="-1"
                                d="M 195,115
    A 80,80,0,
    1,0,
    42.07261569866705,147.88763626297424
  L 67.59720020413359,136.37696357093324
            A 52,52,0,
            1,1,
            167,115 Z"
                                role="img"
                              ></path>
                            </g>
                            <g
                              class="recharts-layer recharts-pie-sector"
                              tabindex="-1"
                            >
                              <path
                                cx="115"
                                cy="115"
                                name="Total returns"
                                class="recharts-sector h-45 w-40 outline-none md:h-[230px] md:w-[230px]"
                                stroke="#fff"
                                fill="#30B48E"
                                cursor="pointer"
                                tabindex="-1"
                                d="M 42.07261569866705,147.88763626297424
    A 80,80,0,
    0,0,
    195,115.00000000000001
  L 167,115.00000000000001
            A 52,52,0,
            0,1,
            67.59720020413359,136.37696357093324 Z"
                                role="img"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <div
                        tabindex="-1"
                        class="recharts-tooltip-wrapper"
                        style="
                          visibility: hidden;
                          pointer-events: none;
                          position: absolute;
                          top: 0px;
                          left: 0px;
                        "
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  class="mt-[26px] flex flex-col gap-6 md:mt-0 md:justify-center md:gap-5"
                >
                  <div
                    class="border-border-light flex flex-col items-center gap-1 rounded border px-4 py-2 md:min-w-28 md:items-start"
                  >
                    <p class="text-sm font-medium text-dark-2">
                      Total value of investment
                    </p>
                    <p
                      class="whitespace-nowrap text-xl font-semibold text-success-1"
                    >
                      ₹
                      <!-- -->8,811.71
                    </p>
                  </div>
                  <div
                    class="flex flex-wrap items-start justify-between md:flex-col md:flex-nowrap md:gap-3"
                  >
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-2">
                        <div
                          class="h-4 w-4 rounded"
                          style="background-color: #ae8ad2"
                        ></div>
                        <p
                          class="text-[13px] font-medium leading-[20px] text-dark-2"
                        >
                          Invested amount
                        </p>
                      </div>
                      <p
                        class="font-sm whitespace-nowrap font-semibold text-dark-6"
                      >
                        ₹
                        <!-- -->5,000.00
                      </p>
                    </div>
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-2">
                        <div
                          class="h-4 w-4 rounded"
                          style="background-color: #30b48e"
                        ></div>
                        <p
                          class="text-[13px] font-medium leading-[20px] text-dark-2"
                        >
                          Total returns
                        </p>
                      </div>
                      <p
                        class="font-sm whitespace-nowrap font-semibold text-dark-6"
                      >
                        ₹
                        <!-- -->3,811.71
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-6">
              <!--$-->
              <div class="no-scrollbar overflow-x-auto">
                <div class="min-w-[600px]">
                  <table
                    class="w-full border-separate border-spacing-0 rounded-2xl border border-gray-200 text-center"
                  >
                    <thead>
                      <tr class="text-center">
                        <th
                          class="h-[57px] text-center border-r last:border-r-0 border-gray-200 text-sm font-medium border-t-0 min-w-[119px]"
                        >
                          Year
                        </th>
                        <th
                          class="h-[57px] text-center border-r last:border-r-0 border-gray-200 text-sm font-medium border-t-0 min-w-[120px]"
                        >
                          Cumulative Investment
                        </th>
                        <th
                          class="h-[57px] text-center border-r last:border-r-0 border-gray-200 text-sm font-medium border-t-0 min-w-[120px]"
                        >
                          Cumulative <br />
                          return
                        </th>
                        <th
                          class="h-[57px] text-center border-r last:border-r-0 border-gray-200 text-sm font-medium border-t-0 min-w-[120px]"
                        >
                          Cumulative <br />
                          return %
                        </th>
                        <th
                          class="h-[57px] text-center border-r last:border-r-0 border-gray-200 text-sm font-medium border-t-0 min-w-[119px]"
                        >
                          Total value of <br />
                          investment
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <span>2025</span>
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹5,000.00
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹600.00
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          12.00%
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹5,600.00
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <span>2026</span>
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹5,600.00
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹1,272.00
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          25.44%
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹6,272.00
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <span>2027</span>
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹6,272.00
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹2,024.64
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          40.49%
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹7,024.64
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <span>2028</span>
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹7,024.64
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹2,867.60
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          57.35%
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹7,867.60
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <span>2029</span>
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹7,867.60
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹3,811.71
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          76.23%
                        </td>
                        <td
                          class="h-[57px] text-center text-[13px] font-medium border-r border-t last:border-r-0 border-gray-200"
                        >
                          ₹8,811.71
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!--/$-->
            </div>
            <hr class="my-6 h-px border-0 bg-grey-7" />
            <div class="flex flex-col gap-4">
              <p class="text-lg font-semibold leading-[26px] text-dark-6">
                Top
                <!-- -->Lumpsum<!-- -->
                Mutual Funds
              </p>
              <a
                target="_blank"
                href="/mutual-funds/mirae-asset-nyse-fang-etf-fund-of-fund-direct-growth-details-104456"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000BRKM.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        Mirae Asset NYSE FANG+ ETF Fund of Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Global - Other</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >41.71%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >0.68%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹2010.4</span></span
                      >
                    </div>
                  </div>
                </div></a
              ><a
                target="_blank"
                href="/mutual-funds/bank-of-india-credit-risk-fund-direct-growth-details-105889"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C00001UQY.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        Bank of India Credit Risk Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Debt</span><span class="mx-1">•</span
                        ><span>Credit Risk</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >37.59%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >0.98%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹113.6</span></span
                      >
                    </div>
                  </div>
                </div></a
              ><a
                target="_blank"
                href="/mutual-funds/sbi-psu-direct-growth-details-105051"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C00003HJY.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        SBI PSU
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Other</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >28.86%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >0.78%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹4542.8</span></span
                      >
                    </div>
                  </div>
                </div></a
              ><a
                target="_blank"
                href="/mutual-funds/motilal-oswal-midcap-fund-direct-growth-details-104974"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000563U.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        Motilal Oswal Midcap Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Mid-Cap</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >28.46%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >0.65%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹26421.1</span></span
                      >
                    </div>
                  </div>
                  <img
                    alt="top-rated"
                    loading="lazy"
                    width="18"
                    height="50"
                    decoding="async"
                    data-nimg="1"
                    class="absolute right-[8px] top-[-3px] md:left-[13px] md:top-[-16px] md:-rotate-90"
                    style="color: transparent"
                    src="/calculator/next-calculator-assets/top-rated.svg"
                  /></div></a
              ><a
                target="_blank"
                href="/mutual-funds/mirae-asset-s-p-500-top-50-etf-fund-of-fund-direct-growth-details-104838"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000BRKM.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        Mirae Asset S&amp;P 500 Top 50 ETF Fund of Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Global - Other</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >28.21%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >0.64%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹685.2</span></span
                      >
                    </div>
                  </div>
                </div></a
              ><a
                target="_blank"
                href="/mutual-funds/hdfc-infrastructure-fund-direct-growth-details-100119"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C00009534.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        HDFC Infrastructure Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Infrastructure</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >27.87%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >1.07%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹2341.1</span></span
                      >
                    </div>
                  </div>
                </div></a
              >
            </div>
            <div class="emi-seo-content mt-6">
              <h2>Lump Sum Calculator</h2>

              <p>
                A Lump Sum Calculator estimates the future value of a one-time
                investment based on the amount, expected rate of return, and
                duration. The compound interest formula predicts how your
                investment will grow over time. This helps in financial planning
                for retirement, education, and other important events.
              </p>

              <p>
                The online calculator provides a clear glimpse of the possible
                growth of your invested money and the interest earned over a
                pre-defined period.
              </p>

              <h2>What is a Lump Sum Calculator?</h2>

              <p>
                A Lump Sum Calculator is an online tool designed to estimate
                prospective returns depending on variables such as investment
                amount, estimated rate of return, and investment term.
              </p>

              <p>
                This online calculator allows investors to simulate various
                scenarios and evaluate the potential growth of their investment
                in different mutual fund schemes and other instruments. This
                helps in choosing a suitable scheme to achieve your financial
                goals.
              </p>

              <h2>How does an online Lump Sum Calculator work?</h2>

              <p>You only need to input the following information:</p>
              <ul>
                <li>Investment amount</li>
                <li>Investment duration</li>
                <li>The estimated rate of return</li>
              </ul>

              <p>
                The online Lump Sum calculator gives you the total returns,
                along with the interest earnings, based on these three factors.
                This Lump Sum investment calculator streamlines the process by
                providing fast results. This helps you to make informed
                decisions without the headache of tedious computations.
              </p>

              <p>
                The online Lump Sum calculators use a simple formula to compute
                the projected growth of an invested amount for a pre-defined
                period.
              </p>

              <p>
                <code>A = P(1 + r/n)<sup>nt</sup></code>
              </p>

              <p>Where:</p>
              <ul>
                <li>
                  <strong>A</strong> is the future value of the Lump Sum
                  investment
                </li>
                <li><strong>P</strong> is the invested amount</li>
                <li><strong>r</strong> is the annual rate of interest</li>
                <li><strong>t</strong> is the investment duration in years</li>
                <li>
                  <strong>n</strong> is the frequency of compounding per year
                </li>
              </ul>

              <h2>Benefits of Using a Lump Sum Calculator</h2>

              <ul>
                <li>
                  Investing a large sum allows you to capitalize on market
                  growth.
                </li>
                <li>
                  Ideal for investments over 10-15 years to leverage
                  compounding.
                </li>
                <li>
                  Provides a convenient one-time investment without monthly
                  contributions, which you may miss at times.
                </li>
                <li>Lump Sum Calculators simplify investment management.</li>
              </ul>
            </div>
            <div class="pt-6">
              <span
                class="text-xl font-semibold not-italic leading-7 text-dark-1"
                >Frequently asked questions</span
              >
              <div class="pt-6">
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="tab=1">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                        :data-state="tab===1?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            Is the Lump Sum Calculator accurate?
                          </h3>
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:hidden"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                          /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      v-if="tab===1"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        Lump Sum Calculators give a projected return on your
                        investment based on the amount, duration and interest
                        rate. However, the actual returns on your investment may
                        differ.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="tab=2">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                        :data-state="tab===2?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            When should one prefer a Lump Sum investment?
                          </h3>
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:hidden"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                          /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      v-if="tab===2"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        If you have a large amount in hand or cash deposits in
                        savings accounts you can opt for a Lump Sum investment.
                        Similarly, you may consider a lump sum investment after
                        receiving a large amount like an annual bonus.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="tab=3">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                        :data-state="tab===3?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            Is Lump Sum Calculator easy to use?
                          </h3>
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:hidden"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                          /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      v-if="tab===3"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        Yes, the lump sum calculator is simple and easy to use.
                        You just need to enter the details like amount, interest
                        rate and duration to get the projected value of your
                        investment.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="tab=4">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                        :data-state="tab===4?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            Where can I park my funds for lump sum investment?
                          </h3>
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:hidden"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=closed]:hidden group-data-[state=open]:block"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/chevron-up.svg"
                          /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      v-if="tab===4"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        You can choose mutual funds and other investment schemes
                        for lump sum investment.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class=" top-28 mt-16 xs:hidden max-w-[320px] shrink-0 self-start md:block"
        >
          <div class="flex flex-col gap-3">
            <div
              class="mb-5 flex flex-col rounded-2xl border border-grey-7 p-4"
            >
              <div class="flex flex-col items-center justify-center">
                <div
                  class="text-center text-[13px] font-semibold not-italic leading-5 text-grey-8"
                >
                  Invest Right, Invest Now
                </div>
                <div
                  class="pt-2 text-center text-lg font-semibold not-italic leading-[26px] text-dark-6"
                >
                  Trusted by 1 cr+ Indians for their wealth-building needs
                </div>
                <div class="my-6 rounded-lg border border-gray-300 px-4">
                  <div class="m-auto mt-2 flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base2">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text--primary-accent relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        0
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-grey-8">
                      Account maintenance charges (AMC)
                    </div>
                  </div>
                  <hr class="my-2 h-px w-full bg-gray-300" />
                  <div class="m-auto flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base2">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text-brand-light-purple relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        0
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-grey-8">
                      Commission on Mutual Funds and IPOs
                    </div>
                  </div>
                  <hr class="my-2 h-px w-full bg-gray-300" />
                  <div class="m-auto mb-2 flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base2">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text-brand-light-purple relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        20
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-grey-8">
                      Brokerage of up to ₹20/order on Equity and F&amp;O
                    </div>
                  </div>
                </div>
              </div>
              <div class="relative flex items-center text-base leading-6">
                <div
                  class="absolute left-4 flex items-center text-sm font-semibold leading-5 text-black"
                >
                  <img
                    alt="indian-flag"
                    loading="lazy"
                    width="16"
                    height="12"
                    decoding="async"
                    data-nimg="1"
                    class="mr-1"
                    style="color: transparent"
                    src="@/styles/img/calculator/next-calculator-assets/indian-flag.svg"
                  /><span class="font-semibold">+91</span>
                </div>
                <input
                  autocomplete="off"
                  autocorrect="off"
                  type="tel"
                  class="h-[52px] w-full gap-3 rounded-lg border !border-grey-9 !bg-light-1 !px-4 !py-2 !pl-[68px] outline-none !mb-0"
                  placeholder="Mobile number"
                  name="phoneInput"
                  value=""
                />
              </div>
              <span class="text-xs text-red-600"></span
              ><button
                class="cursor-pointer px-4 text-sm font-semibold disabled:cursor-not-allowed hover-none:bg-primary-dark bg-primary-base text-white active:bg-primary-dark2 disabled:bg-primary-base/50 dark:bg-purpleDark-4 rounded-lg mt-3 w-full py-3"
              >
                Start Investing
              </button>
              <p
                class="pt-2 text-[10px] font-normal not-italic leading-4 text-dark-2"
              >
                By signing up, you agree to receive transaction updates from
                Upstox.
              </p>
            </div>
            <div
              class="flex flex-col text-base font-semibold not-italic leading-6"
            >
              <p class="border-b border-solid border-b-grey-7 pb-6 text-[18px]">
                Related Lumpsum Calculators
              </p>
              <a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/sbi-lumpsum-calculator/"
                ><p>SBI Lumpsum calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/hdfc-lumpsum-calculator/"
                ><p>HDFC Lumpsum calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/kotak-lumpsum-calculator/"
                ><p>Kotak Lumpsum calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/icici-lumpsum-calculator/"
                ><p>ICICI Lumpsum calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/axis-lumpsum-calculator/"
                ><p>Axis Lumpsum calculator</p></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped lang="scss">
p {
  /* margin: 0 !important; */
}

.upstox-radio-group {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    padding: .25rem .5rem .25rem 0;
    .radio-wrapper {
        display: flex;
        align-items: center
    }

    .radio-input {
        display: none
    }

    .radio-label {
        position: relative;
        display: flex;
        cursor: pointer;
        align-items: center;
        padding-left: 1.5rem;
        font-size: .875rem;
        line-height: 1.25rem;
        font-weight: 400;
        line-height: normal;
        --tw-text-opacity: 1;
        color: rgb(68 68 68/var(--tw-text-opacity));
        outline: none
    }

    .radio-label:before {
        position: absolute;
        left: 0;
        height: 1rem;
        width: 1rem;
        border-radius: 50%;
        border-width: 1px;
        border-style: solid;
        --tw-border-opacity: 1;
        border-color: rgb(0 0 0/var(--tw-border-opacity))
    }

    .radio-label:after,.radio-label:before {
        --tw-content: "";
        content: var(--tw-content)
    }

    .radio-input:checked+.radio-label:after {
        position: absolute;
        left: 3px;
        top: 50%;
        height: .625rem;
        width: .625rem;
        --tw-translate-y: -50%;
        transform: translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
        border-radius: 50%;
        --tw-bg-opacity: 1;
        background-color: rgb(0 0 0/var(--tw-bg-opacity));
        --tw-content: "";
        content: var(--tw-content)
    }
}

</style>

